import { Component, ViewChild, TemplateRef, ElementRef, Input, OnInit, OnChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DatePipe } from '@angular/common';
import { AppService } from '../app.service';
import { qmsService } from '../qms/qms.service';
import { forkJoin, firstValueFrom } from 'rxjs';
import { PaginationService } from '../PaginationService';
import { messageService } from '../message.service';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { EditorComponent } from '../editor/editor.component';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
@Component({
  selector: 'app-finding-due-date',
  templateUrl: './finding-due-date.component.html',
  styleUrls: ['./finding-due-date.component.scss']
})
export class FindingDueDateComponent implements OnInit, OnChanges {
  selectedReportFooter: any;
  reportFooterDropdown1: any = [];
  reportFooterDropdown: any = [];
  reportFooterFieldValidation: any;
  refreshbreadcrumb: boolean = true;
  selectedGroupValue: any = null;
  isProcessing: boolean = false;
  showReportFlagValue: any;
  showCharts: boolean = false;
  groupValueDropdown: any[];
  groupdataList: any = [];
  selectedDepartmentValue: any = [];
  searchByDepartmentCode: any = null;
  departmentCodeDropdown: any = [];
  dropDownForDepartmentCode: any = [];
  annualRefNo: any;
  findingDuedateTableReportDataList: any = [];
  findingClosureTableReportDataList: any = [];
  findingDueInDaysList: any = [];
  findingClosureInDaysList: any = [];
  chartOptionsForFindingDueInDays: any;
  chartOptionsForFindingClosureInDays: any;
  chartOptionsForFindingDueInDaysZoom: any;
  chartOptionsForFindingClosureInDaysZoom: any;
  departmentSearchText: string = '';
  isDropdownDisabled: boolean = true;
  titleName = '';
  clickedType = "";
  clickedVal = "";
  clickedStageStatusVal = "";
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  users: any[];
  pager: any = {};
  pagedItems3: any[];
  pagedItems4: any[];

  @ViewChild(BreadcrumbComponent) breadcrumbComponent!: BreadcrumbComponent;
  constructor(public dialog: MatDialog, public route: ActivatedRoute, public appService: AppService, public message: messageService, public router: Router, public snackBar: MatSnackBar,
    public elem: ElementRef, public service: messageService, public qmsservice: qmsService, public datePipe: DatePipe, public activatedRoute: ActivatedRoute, public paginationService: PaginationService) {
    this.appService.isProcessingRep = false;
  }

  @ViewChild('reportPopup', { static: true }) reportPopup: TemplateRef<any>;
  visibleReportPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('reportPopupForZoom', { static: true }) reportPopupForZoom: TemplateRef<any>;
  visibleReportPopupForZoom: MatDialogRef<TemplateRef<any>>;
  reportPopupConfig = {
    width: '120%',
    height: '680px',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px', left: '125px' },
    maxWidth: '90vw',
  };

  selectBoxeForGroupValue() {
    this.isProcessing = true;
    this.groupValueDropdown = [];
    this.groupValueDropdown = this.groupdataList.map((group: { groupId: any; groupName: any; }) => ({
      valueExp: group.groupId,
      displayExp: group.groupName
    }));
    this.isProcessing = false;
  }

  handleDropDownValidation(fieldId: string, selectedItems: [] | string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    const isMultiSelectValidation = (fieldId === 'pdf-select-all');
    const shouldBeRed = isMultiSelectValidation ? !selectedItems.length : !selectedItems;
    if (field) {
      field.style.color = shouldBeRed ? 'red' : '#005c8a';
    }
  }
  resetFunction() {
    this.searchByDepartmentCode = null;
    this.showCharts = false;
  }

  resetFunctionForButton() {
    this.searchByDepartmentCode = null;
    this.showCharts = false;
  }
  genFindnigReport() {
    console.log("finding data", this.selectedGroupValue);
    console.log("finding data", this.searchByDepartmentCode);

    if (this.selectedGroupValue) {

      const data = {
        groupId: this.selectedGroupValue ?? null,
        module: "FINDINGS",
        dateRangeAt: null,
        fromDate: null,
        toDate: null,
        intervals: null,
        stageName: null,
        status: null,
        deptCode: this.searchByDepartmentCode ?? null,
        annualRefNo: this.annualRefNo ?? null
      };

      this.isProcessing = true;

      const promises = [
        this.appService.getFindingDueInDaysTableVal(data),
        this.appService.getFindingClosureInDaysTableVal(data)
      ].map(observable => firstValueFrom(observable));

      Promise.all(promises)
        .then(([findingDueInDaysList, findingClosureInDaysList]) => {

          this.findingDueInDaysList = findingDueInDaysList;
          this.findingClosureInDaysList = findingClosureInDaysList;

          this.createChart();
          this.isProcessing = false;

        })
        .catch(error => {
          console.error('Error in forkJoinObservable:', error);
          this.isProcessing = false;
        });

      return;
    }

    const field = document.getElementById('groupNameAlert') as HTMLInputElement;

    if (field) {
      field.style.color = 'red';
    }
  }

  moveTop() {
    this.showCharts = true;
    setTimeout(() => {
      window.scrollTo({ top: 220, behavior: 'smooth' });
    }, 1000);

  }
  clickedChartVal: any;
  chartDoubleClick(val: any) {
    this.createChartZoom(val);
    this.clickedChartVal = val;
    this.visibleReportPopupForZoom = this.dialog.open(this.reportPopupForZoom, this.reportPopupConfig);
    if (val == 1) {
      this.tableDataListForAll("dueInDays", "", "");
      this.clickedType = "dueInDays";
      this.clickedVal = "dueInDays";
      this.clickedStageStatusVal = "";
    }
    if (val == 2) {
      this.tableDataListForAll("closureInDays", "", "");
      this.clickedType = "closureInDays";
      this.clickedVal = "closureInDays";
      this.clickedStageStatusVal = "";
    }
  }

  createChartZoom(val: any) {
    if (val == 1) {
      this.chartOptionsForFindingDueInDaysZoom = {
        animationEnabled: true,
        exportEnabled: true,
        zoomEnabled: true,
        zoomType: "xy",
        toolbar: {
          itemBackgroundColor: "#d3d3d3",
          itemBackgroundColorOnHover: "#3e3e3e",
          buttonBorderColor: "#3e3e3e",
          icon: {
            zoom: {
              backgroundColor: "#007BFF", // Set the background color for the zoom icon
              borderColor: "#007BFF",     // Set the border color for the zoom icon
              borderWidth: 1             // Set the border width for the zoom icon
            }
          }
        },
        legend: {
          cursor: "pointer",
          maxWidth: 370,
          // itemWidth: 150,
          horizontalAlign: "left",
          fontSize: 12,
          fontFamily: "Poppins",
          fontColor: "#0F3659",
          fontWeight: "normal",
        },
        title: {
          text: `Finding Due Date In Days (${this.getTotalCountDueDate()})`,
          fontSize: 20,
          fontFamily: "Poppins",
          horizontalAlign: "left",
          fontColor: "#0F3659",
          fontWeight: "bold",
          click: function (e: any) {
            // Your title click event handler logic goes here
            console.log("Title clicked!");
          }
        },
        data: [{
          type: "pie",
          startAngle: -90,
          indexLabel: "{duedateindays}:{count}",
          showInLegend: true,
          legendText: "{indexLabel}",
          yValueFormatString: "#,###.##''",
          dataPoints: this.getDataPointsForDueInDays(),
          click: this.handleDueInDaysChartClick.bind(this) // Reference the click event handler for the entire pie chart

        }]
      };
    }
    if (val == 2) {
      this.chartOptionsForFindingClosureInDaysZoom = {
        animationEnabled: true,
        exportEnabled: true,
        zoomEnabled: true,
        zoomType: "xy",
        toolbar: {
          itemBackgroundColor: "#d3d3d3",
          itemBackgroundColorOnHover: "#3e3e3e",
          buttonBorderColor: "#3e3e3e",
          icon: {
            zoom: {
              backgroundColor: "#007BFF", // Set the background color for the zoom icon
              borderColor: "#007BFF",     // Set the border color for the zoom icon
              borderWidth: 1             // Set the border width for the zoom icon
            }
          }
        },
        legend: {
          cursor: "pointer",
          maxWidth: 370,
          // itemWidth: 150,
          horizontalAlign: "left",
          fontSize: 12,
          fontFamily: "Poppins",
          fontColor: "#0F3659",
          fontWeight: "normal",
        },
        title: {
          text: `Finding Closure In Days  (${this.getTotalCountClosureInDays()})`,
          fontSize: 20,
          fontFamily: "Poppins",
          horizontalAlign: "left",
          fontColor: "#0F3659",
          fontWeight: "bold",
          click: function (e: any) {
            // Your title click event handler logic goes here
            console.log("Title clicked!");
          }
        },
        data: [{
          type: "pie",
          startAngle: -90,
          indexLabel: "{duedateindays}:{count}",
          showInLegend: true,
          legendText: "{indexLabel}",
          yValueFormatString: "#,###.##''",
          dataPoints: this.getDataPointsForClosureInDays(),
          click: this.handleClosureInDaysChartClick.bind(this) // Reference the click event handler for the entire pie chart

        }]
      };
    }
  }

  createChart() {
    this.chartOptionsForFindingDueInDays = {
      animationEnabled: true,
      exportEnabled: true,
      zoomEnabled: true,
      zoomType: "xy",
      toolbar: {
        itemBackgroundColor: "#d3d3d3",
        itemBackgroundColorOnHover: "#3e3e3e",
        buttonBorderColor: "#3e3e3e",
        icon: {
          zoom: {
            backgroundColor: "#007BFF", // Set the background color for the zoom icon
            borderColor: "#007BFF",     // Set the border color for the zoom icon
            borderWidth: 1             // Set the border width for the zoom icon
          }
        }
      },
      legend: {
        cursor: "pointer",
        maxWidth: 370,
        // itemWidth: 150,
        horizontalAlign: "left",
        fontSize: 12,
        fontFamily: "Poppins",
        fontColor: "#0F3659",
        fontWeight: "normal",
      },
      title: {
        text: `Finding Due Date In Days  (${this.getTotalCountDueDate()})`,
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          // Your title click event handler logic goes here
          console.log("Title clicked!");
        }
      },
      data: [{
        type: "pie",
        startAngle: -90,
        indexLabel: "{duedateindays}:{count}",
        showInLegend: true,
        legendText: "{indexLabel}",
        yValueFormatString: "#,###.##''",
        dataPoints: this.getDataPointsForDueInDays(),
        click: this.handleDueInDaysChartClick.bind(this) // Reference the click event handler for the entire pie chart

      }]
    };
    this.chartOptionsForFindingClosureInDays = {
      animationEnabled: true,
      exportEnabled: true,
      zoomEnabled: true,
      zoomType: "xy",
      toolbar: {
        itemBackgroundColor: "#d3d3d3",
        itemBackgroundColorOnHover: "#3e3e3e",
        buttonBorderColor: "#3e3e3e",
        icon: {
          zoom: {
            backgroundColor: "#007BFF", // Set the background color for the zoom icon
            borderColor: "#007BFF",     // Set the border color for the zoom icon
            borderWidth: 1             // Set the border width for the zoom icon
          }
        }
      },
      legend: {
        cursor: "pointer",
        maxWidth: 370,
        // itemWidth: 150,
        horizontalAlign: "left",
        fontSize: 12,
        fontFamily: "Poppins",
        fontColor: "#0F3659",
        fontWeight: "normal",
      },
      title: {
        text: `Finding Closure In Days  (${this.getTotalCountClosureInDays()})`,
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          // Your title click event handler logic goes here
          console.log("Title clicked!");
        }
      },
      data: [{
        type: "pie",
        startAngle: -90,
        indexLabel: "{duedateindays}:{count}",
        showInLegend: true,
        legendText: "{indexLabel}",
        yValueFormatString: "#,###.##''",
        dataPoints: this.getDataPointsForClosureInDays(),
        click: this.handleClosureInDaysChartClick.bind(this) // Reference the click event handler for the entire pie chart

      }]
    };
    this.moveTop();
  }

  colorList: string[] = [
    '#F9F871',
    '#6B7887',
    '#00A6A9',
    '#00A6A9',
    '#BF83FF',
    '#005C8A',
    '#05004E',
    '#834160',
    '#9EADBD',
    '#BA7393',
    '#DEEBFE',
    '#96E480',
    '#05004E',
    '#839EFF',
    '#00A6A9',
    '#0081A5'
  ];

  colorMethod(val: any, iVal: any) {
    if (val == "Closed" || val == "Completed" || val == "Passed") {
      return "#96E480";
    } else if (val == "Critical" || val == "High") {
      return "#EB5757";
    } else if (val == "Major" || val == "Medium") {
      return "#FF947A";
    } else if (val == "In Progress" || val == "Minor") {
      return "#005C8A";
    } else {
      return this.colorList[iVal];;
    }

  }
  getDataPointsForDueInDays() {
    const dataPoints = this.findingDueInDaysList.map((findingDueInDays: { count: any; duedateindays: any; }, index: any) => ({
      y: findingDueInDays.count,
      indexLabel: `${findingDueInDays.duedateindays}:${findingDueInDays.count}`,
      color: this.colorMethod(findingDueInDays.duedateindays, index)
    }));
    return dataPoints;
  }

  getDataPointsForClosureInDays() {
    const dataPoints = this.findingClosureInDaysList.map((findingClosureInDays: { count: any; closureindays: any; }, index: any) => ({
      y: findingClosureInDays.count,
      indexLabel: `${findingClosureInDays.closureindays}:${findingClosureInDays.count}`,
      color: this.colorMethod(findingClosureInDays.closureindays, index)
    }));
    return dataPoints;
  }


  handleDueInDaysChartClick(e: any): void {
    this.titleName = "Finding Due In Days"
    this.visibleReportPopup = this.dialog.open(this.reportPopup, this.reportPopupConfig);
    this.tableDataList("dueInDays", this.findingDueInDaysList[e.dataPointIndex].duedateindays, "");
    this.clickedType = "Finding Due Date In Days";
    this.clickedVal = this.findingDueInDaysList[e.dataPointIndex].duedateindays;
    this.clickedStageStatusVal = "";
  }
  getTotalCountDueDate() {
    return this.findingDueInDaysList.reduce((total: number, item: { count: number }) => total + item.count, 0);
  }
  handleClosureInDaysChartClick(e: any): void {
    this.titleName = "Finding Closure In Days"
    this.visibleReportPopup = this.dialog.open(this.reportPopup, this.reportPopupConfig);
    this.tableDataList("closureInDays", this.findingClosureInDaysList[e.dataPointIndex].closureindays, "");
    this.clickedType = "Finding Closure In Days";
    this.clickedVal = this.findingClosureInDaysList[e.dataPointIndex].closureindays;
    this.clickedStageStatusVal = "";
  }

  getTotalCountClosureInDays() {
    return this.findingClosureInDaysList.reduce((total: number, item: { count: number }) => total + item.count, 0);
  }
  whereValsForExcel: any;
  tableDataList(type: any, valueOfWhere: any, stageNameForTable: any) {
    console.log("tableDataList");
    let whereVals;
    if (type == "dueInDays") {
      this.showReportFlagValue = 1;
      whereVals = " WHERE DUEDATEINDAYS='" + valueOfWhere + "'"
    } else if (type == "closureInDays") {
      this.showReportFlagValue = 2;
      whereVals = " WHERE CLOSUREINDAYS='" + valueOfWhere + "'"
    }
    this.whereValsForExcel = whereVals;
    let data;
    data = {
      groupId: this.selectedGroupValue ? this.selectedGroupValue : null,
      module: "FINDINGS",
      dateRangeAt: null,
      fromDate: null,
      toDate: null,
      intervals: null,
      stageName: null,
      status: null,
      deptCode: this.searchByDepartmentCode ? this.searchByDepartmentCode : null,
      annualRefNo: this.annualRefNo ?? null,
      wherVal: whereVals
    }
    this.isProcessing = true;
    if (this.showReportFlagValue == 1) {
      forkJoin([
        this.appService.getFindingDueInDaysTableValDetails(data)]).subscribe(([dueList]) => {
          this.findingDuedateTableReportDataList = dueList;
          this.calculateTotalPages = this.collectionSize / this.perPage;
          this.pager.totalPages = undefined;
          this.collectionSize = this.findingDuedateTableReportDataList.length;
          this.totalPages = Math.ceil(this.findingDuedateTableReportDataList.length / this.itemsPerPage);
          this.setPage4(1, 0);
          this.isProcessing = false;
        });
      this.columnList = "Assigned To User Details,Completed On,Reference,Comments,Immediate Correction,Auditor Comments,Expected Closure Date,Closure Comments,Actual Closed Date,Response Reviewed By User,Response Reviewer,Response Review Requested On,Response Review Completed On,Response Reviewer Comments,Response Review Status,Implementation Reviewed By User,Implementation Reviewer,Implementation Review Requested On,Implementation Review Completed On,Implementation Reviewer Comments,Implementation Review Status,Is Implementation Accepted,Expected PA Closure Date,Expected CA Closure Date,Response Verification Requested On,Response Verification Comments,Response Verified On,Implementation Verification Requested On,Implementation Verified On,Implementation Verification Comments,Final Risk Score,Final Risk Status,Created On,Created By,Created By User,Updated On,Updated By,Updated By User,Duedateindays,Group Id,Sub Group Name,Annual Ref No,Org Id,Finding Id,AU No,Seq,Finding Short Description,Status,Is Capa Required,Capa Details,Finding,Severity,Response Due Date,Root Cause Analysis,Corrective Action,Preventive Action,Deliverables,Assigned To User,Assigned To,Assigned To Department";
    } else if (this.showReportFlagValue == 2) {
      forkJoin([
        this.appService.getFindingClosureInDaysTableValDetails(data)]).subscribe(([fiList]) => {
          this.findingClosureTableReportDataList = fiList;
          this.calculateTotalPages = this.collectionSize / this.perPage;
          this.pager.totalPages = undefined;
          this.collectionSize = this.findingClosureTableReportDataList.length;
          this.totalPages = Math.ceil(this.findingClosureTableReportDataList.length / this.itemsPerPage);
          this.setPage3(1, 0);
          this.isProcessing = false;
        });
      this.columnList = "Closureindays,Group ID,Sub Group Name,Annual Ref No,Org ID,Finding ID,AU No,Seq,Finding Short Description,Status,Is CAPA Required,CAPA Details,Finding,Severity,Response Due Date,Root Cause Analysis,Corrective Action,Preventive Action,Deliverables,Assigned To User,Assigned To,Assigned To Department,Assigned To User Details,Completed On,Reference,Comments,Immediate Correction,Auditor Comments,Expected Closure Date,Closure Comments,Actual Closed Date,Response Reviewed By User,Response Reviewer,Response Review Requested On,Response Review Completed On,Response Reviewer Comments,Response Review Status,Implementation Reviewed By User,Implementation Reviewer,Implementation Review Requested On,Implementation Review Completed On,Implementation Reviewer Comments,Implementation Review Status,Is Implementation Accepted,Expected PA Closure Date,Expected CA Closure Date,Response Verification Requested On,Response Verification Comments,Response Verified On,Implementation Verification Requested On,Implementation Verified On,Implementation Verification Comments,Final Risk Score,Final Risk Status,Created On,Created By,Created By User,Updated On,Updated By,Updated By User";
    }
  }


  tableDataListForAll(type: any, valueOfWhere: any, stageNameForTable: any) {
    console.log("tableDataList");
    let whereVals;
    if (type == "dueInDays") {
      this.showReportFlagValue = 1;
      whereVals = "";
    } else if (type == "closureInDays") {
      this.showReportFlagValue = 2;
      whereVals = ""
    }
    this.whereValsForExcel = whereVals;
    let data = {
      groupId: this.selectedGroupValue ? this.selectedGroupValue : null,
      module: "FINDINGS",
      dateRangeAt: null,
      fromDate: null,
      toDate: null,
      intervals: null,
      stageName: null,
      status: null,
      deptCode: this.searchByDepartmentCode ? this.searchByDepartmentCode : null,
      annualRefNo: this.annualRefNo ?? null,
      wherVal: whereVals
    }
    this.isProcessing = true;
    if (this.showReportFlagValue == 1) {
      forkJoin([
        this.appService.getFindingDueInDaysTableValDetails(data)]).subscribe(([dueList]) => {
          this.findingDuedateTableReportDataList = dueList;
          this.calculateTotalPages = this.collectionSize / this.perPage;
          this.pager.totalPages = undefined;
          this.collectionSize = this.findingDuedateTableReportDataList.length;
          this.totalPages = Math.ceil(this.findingDuedateTableReportDataList.length / this.itemsPerPage);
          this.setPage4(1, 0);
          this.isProcessing = false;
        });
      this.columnList = "Assigned To User Details,Completed On,Reference,Comments,Immediate Correction,Auditor Comments,Expected Closure Date,Closure Comments,Actual Closed Date,Response Reviewed By User,Response Reviewer,Response Review Requested On,Response Review Completed On,Response Reviewer Comments,Response Review Status,Implementation Reviewed By User,Implementation Reviewer,Implementation Review Requested On,Implementation Review Completed On,Implementation Reviewer Comments,Implementation Review Status,Is Implementation Accepted,Expected PA Closure Date,Expected CA Closure Date,Response Verification Requested On,Response Verification Comments,Response Verified On,Implementation Verification Requested On,Implementation Verified On,Implementation Verification Comments,Final Risk Score,Final Risk Status,Created On,Created By,Created By User,Updated On,Updated By,Updated By User,Duedateindays,Group Id,Sub Group Name,Annual Ref No,Org Id,Finding Id,AU No,Seq,Finding Short Description,Status,Is Capa Required,Capa Details,Finding,Severity,Response Due Date,Root Cause Analysis,Corrective Action,Preventive Action,Deliverables,Assigned To User,Assigned To,Assigned To Department";
    } else if (this.showReportFlagValue == 2) {
      forkJoin([
        this.appService.getFindingClosureInDaysTableValDetails(data)]).subscribe(([fiList]) => {
          this.findingClosureTableReportDataList = fiList;
          this.calculateTotalPages = this.collectionSize / this.perPage;
          this.pager.totalPages = undefined;
          this.collectionSize = this.findingClosureTableReportDataList.length;
          this.totalPages = Math.ceil(this.findingClosureTableReportDataList.length / this.itemsPerPage);
          this.setPage3(1, 0);
          this.isProcessing = false;
        });
      this.columnList = "Closureindays,Group ID,Sub Group Name,Annual Ref No,Org ID,Finding ID,AU No,Seq,Finding Short Description,Status,Is CAPA Required,CAPA Details,Finding,Severity,Response Due Date,Root Cause Analysis,Corrective Action,Preventive Action,Deliverables,Assigned To User,Assigned To,Assigned To Department,Assigned To User Details,Completed On,Reference,Comments,Immediate Correction,Auditor Comments,Expected Closure Date,Closure Comments,Actual Closed Date,Response Reviewed By User,Response Reviewer,Response Review Requested On,Response Review Completed On,Response Reviewer Comments,Response Review Status,Implementation Reviewed By User,Implementation Reviewer,Implementation Review Requested On,Implementation Review Completed On,Implementation Reviewer Comments,Implementation Review Status,Is Implementation Accepted,Expected PA Closure Date,Expected CA Closure Date,Response Verification Requested On,Response Verification Comments,Response Verified On,Implementation Verification Requested On,Implementation Verified On,Implementation Verification Comments,Final Risk Score,Final Risk Status,Created On,Created By,Created By User,Updated On,Updated By,Updated By User";
    }
  }
  cancelReportPopupFunction() {
    this.visibleReportPopup.close();
  }
  cancelReportPopupForZoomFunction() {
    this.visibleReportPopupForZoom.close();
  }

  //Excell & PDF

  popupDataTitle: any = {};
  cancelReportPopup() {
    this.visibleExcelPdfPopup.close();
    this.manuallyPicked = false;
    this.selectedColumns = "";
  }
  selectedColumns: any;
  columnList: any;
  dropDownForPdfColumn: any;
  isForExcel: boolean = false;
  @ViewChild('excelPdfPopup', { static: true }) excelPdfPopup: TemplateRef<any>;
  excelPdfPopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  }
  visibleExcelPdfPopup: MatDialogRef<TemplateRef<any>>;
  reportObj: any = {};
  isSaveReport: boolean = false;

  pdfDetailSearchText: string = '';
  templateid: number;
  reportTemplateFieldValidation: any;
  reportLogoFieldValidation: any;
  onReportLogoValueSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.templateid = item;
      if (this.reportLogoFieldValidation != undefined) {
        this.reportLogoFieldValidation.style.color = '#005c8a';
      }

    }
  }
  reportName: any;
  generateReport(value: any) {
    if (value == 'Pdf' && this.manuallyPicked && !this.selectedColumns.length) {
      this.showSnackBar('Please select the Columns', 'E');
    } else if (value == 'Pdf' && this.manuallyPicked && this.selectedColumns.length > 12) {
      alert('Selected columns exceeded the limit. Limit 12, Selected ' + this.selectedColumns.length);
    } else {
      this.appService.isProcessingRep = true;
      let tname = "";
      let colList = "";
      let fieldList = "";
      if (this.showReportFlagValue == 1) {
        tname = "QMS_AU_FINDINGS_DUEDATE_VW";
        colList = "SEQ,FINDING,FINDING_ID,DUE_DATE,ANNUAL_REF_NO,SUB_GROUP_NAME,STATUS,ASSIGNED_TO_USER,ASSIGNED_TO_DEPARTMENT,FINDING_SHORT_DESCRIPTION,REFERENCE,SEVERITY,ASSIGNED_TO_USER_DETAILS,COMPLETED_ON,COMMENTS,IMMEDIATE_CORRECTION,AUDITOR_COMMENTS,EXPECTED_CLOSURE_DATE,CLOSURE_COMMENTS,ACTUAL_CLOSED_DATE,RESPONSE_REVIEWED_BY_USER,RESPONSE_REVIEWER,RESPONSE_REVIEW_REQUESTED_ON,RESPONSE_REVIEW_COMPLETED_ON,RESPONSE_REVIEWER_COMMENTS,RESPONSE_REVIEW_STATUS,IMPLEMENTATION_REVIEWED_BY_USER,IMPLEMENTATION_REVIEWER,IMPLEMENTATION_REVIEW_REQUESTED_ON,IMPLEMENTATION_REVIEW_COMPLETED_ON,IMPLEMENTATION_REVIEWER_COMMENTS,IMPLEMENTATION_REVIEW_STATUS,IS_IMPLEMENTAITON_ACCEPTED,EXPECTED_PA_CLOSURE_DATE,EXPECTED_CA_CLOSURE_DATE,RESPONSE_VERIFICATION_REQUESTED_ON,RESPONSE_VERIFICATION_COMMENTS,RESPONSE_VERIFIED_ON,IMPLEMENTATION_VERIFICATION_REQUESTED_ON,IMPLEMENTATION_VERIFIED_ON,IMPLEMENTATION_VERIFICATION_COMMENTS,FINAL_RISK_SCORE,FINAL_RISK_STATUS,CREATED_ON,CREATED_BY,CREATED_BY_USER,UPDATED_ON,UPDATED_BY,UPDATED_BY_USER,DUEDATEINDAYS,AU_NO,IS_CAPA_REQUIRED,CAPA_DETAILS,ROOT_CAUSE_ANALYSIS,CORRECTIVE_ACTION,PREVENTIVE_ACTION,DELIVERABLES,ASSIGNED_TO";
        fieldList = "Seq,Finding,Finding Id,Response Due Date,Annual Ref No,Sub Group Name,Status,Assigned To User,Assigned To Department,Finding Short Description,Reference,Severity,Assigned To User Details,Completed On,Comments,Immediate Correction,Auditor Comments,Expected Closure Date,Closure Comments,Actual Closed Date,Response Reviewed By User,Response Reviewer,Response Review Requested On,Response Review Completed On,Response Reviewer Comments,Response Review Status,Implementation Reviewed By User,Implementation Reviewer,Implementation Review Requested On,Implementation Review Completed On,Implementation Reviewer Comments,Implementation Review Status,Is Implementation Accepted,Expected PA Closure Date,Expected CA Closure Date,Response Verification Requested On,Response Verification Comments,Response Verified On,Implementation Verification Requested On,Implementation Verified On,Implementation Verification Comments,Final Risk Score,Final Risk Status,Created On,Created By,Created By User,Updated On,Updated By,Updated By User,Duedateindays,AU No,Is Capa Required,Capa Details,Root Cause Analysis,Corrective Action,Preventive Action,Deliverables,Assigned To";

      } else if (this.showReportFlagValue == 2) {
        tname = "QMS_AU_FINDINGS_CLOSUREINDAYS_VW";
        colList = "CLOSUREINDAYS,GROUP_ID,SUB_GROUP_NAME,ANNUAL_REF_NO,ORG_ID,FINDING_ID,AU_NO,SEQ,FINDING_SHORT_DESCRIPTION,STATUS,IS_CAPA_REQUIRED,CAPA_DETAILS,FINDING,SEVERITY,DUE_DATE,ROOT_CAUSE_ANALYSIS,CORRECTIVE_ACTION,PREVENTIVE_ACTION,DELIVERABLES,ASSIGNED_TO_USER,ASSIGNED_TO,ASSIGNED_TO_DEPARTMENT,ASSIGNED_TO_USER_DETAILS,COMPLETED_ON,REFERENCE,COMMENTS,IMMEDIATE_CORRECTION,AUDITOR_COMMENTS,EXPECTED_CLOSURE_DATE,CLOSURE_COMMENTS,ACTUAL_CLOSED_DATE,RESPONSE_REVIEWED_BY_USER,RESPONSE_REVIEWER,RESPONSE_REVIEW_REQUESTED_ON,RESPONSE_REVIEW_COMPLETED_ON,RESPONSE_REVIEWER_COMMENTS,RESPONSE_REVIEW_STATUS,IMPLEMENTATION_REVIEWED_BY_USER,IMPLEMENTATION_REVIEWER,IMPLEMENTATION_REVIEW_REQUESTED_ON,IMPLEMENTATION_REVIEW_COMPLETED_ON,IMPLEMENTATION_REVIEWER_COMMENTS,IMPLEMENTATION_REVIEW_STATUS,IS_IMPLEMENTAITON_ACCEPTED,EXPECTED_PA_CLOSURE_DATE,EXPECTED_CA_CLOSURE_DATE,RESPONSE_VERIFICATION_REQUESTED_ON,RESPONSE_VERIFICATION_COMMENTS,RESPONSE_VERIFIED_ON,IMPLEMENTATION_VERIFICATION_REQUESTED_ON,IMPLEMENTATION_VERIFIED_ON,IMPLEMENTATION_VERIFICATION_COMMENTS,FINAL_RISK_SCORE,FINAL_RISK_STATUS,CREATED_ON,CREATED_BY,CREATED_BY_USER,UPDATED_ON,UPDATED_BY,UPDATED_BY_USER";
        fieldList = "Closureindays,Group ID,Sub Group Name,Annual Ref No,Org ID,Finding ID,AU No,Seq,Finding Short Description,Status,Is CAPA Required,CAPA Details,Finding,Severity,Response Due Date,Root Cause Analysis,Corrective Action,Preventive Action,Deliverables,Assigned To User,Assigned To,Assigned To Department,Assigned To User Details,Completed On,Reference,Comments,Immediate Correction,Auditor Comments,Expected Closure Date,Closure Comments,Actual Closed Date,Response Reviewed By User,Response Reviewer,Response Review Requested On,Response Review Completed On,Response Reviewer Comments,Response Review Status,Implementation Reviewed By User,Implementation Reviewer,Implementation Review Requested On,Implementation Review Completed On,Implementation Reviewer Comments,Implementation Review Status,Is Implementation Accepted,Expected PA Closure Date,Expected CA Closure Date,Response Verification Requested On,Response Verification Comments,Response Verified On,Implementation Verification Requested On,Implementation Verified On,Implementation Verification Comments,Final Risk Score,Final Risk Status,Created On,Created By,Created By User,Updated On,Updated By,Updated By User";
      }
      console.log(value, "--------------------");
      const data = {

        groupId: this.qmsservice.selectedGroup
      }

      const data1: any = {

        tableOrViewName: tname,
        columnsList: colList,
        fieldLabelsList: fieldList,
        invisibleColumn: "",
        orderByClause: "",
        fieldSizeList: "",
        columnsListarray: [],
        fieldColumnarray: [],
        invisibleColumnarray: [],
        fieldSizeListArray: [],
        status: null,
        codelistGroup: null,
        manualEntryDataFields: null,
        groupId: this.qmsservice.selectedActivityGroupId,
        chartStatus: null,
        reModule: "qms",
        footer: this.selectedReportFooter,
        logoId: this.selectedReportLogoValue ?? 0,
        isSaveRep: this.isSaveReport ? 'Y' : 'N',
        reportName: this.reportName ?? `${this.clickedType}_${this.clickedVal}`,
        currentStatus: "NA",
        groupName: this.qmsservice.activity.groupName + "",
      }
      let data2 = {

        groupId: this.selectedGroupValue ? this.selectedGroupValue : null,
        module: this.qmsservice.moduleName,
        dateRangeAt: null,
        fromDate: null,
        toDate: null,
        intervals: null,
        stageName: null,
        status: null,
        wherVal: this.whereValsForExcel
      }
      this.reportObj = { ...data1, ...data, ...data2 };
      debugger;
      const timestamp = Date.now();
      const formattedDate = new Intl.DateTimeFormat('en-US', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
      })
        .format(new Date(timestamp))
        .replaceAll(',', '')
        .replaceAll(' ', '_');

      let fileType = value == 'Excel' ? 'xlsx' : 'pdf';
      const fileName = `${this.clickedType}_${this.clickedVal}_${formattedDate}.${fileType}`;
      if (value == 'Excel') {
        const pdfData = {
          ...this.reportObj, title: this.clickedChartVal, columns: [],
          "informationTab": {
            "Report Name": `${this.clickedType}_${this.clickedVal}` + "Report",
            "Exported By": sessionStorage.getItem("reportsUserName") ? sessionStorage.getItem("reportsUserName") : localStorage.getItem("loggedUserName")
          }
        }
        this.appService.downloadexcelForChart(pdfData, fileName + ".xlsx");
      } else {
        const pdfData = {
          ...this.reportObj, title: `${this.clickedType}_${this.clickedVal}` + "Report", columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.columnList.split(',').slice(0, 10).join(','), pdfPageSize: this.excelPdf.pdfPageSize
        }
        this.appService.downloadPdfForChart(pdfData, fileName + ".pdf");

      }
    }
  }
  openReportPopup(item: any) {
    this.excelPdf.dropDown = this.columnList.split(',').map((column: any) => ({ valueExp: column, displayExp: column }));
    this.pdfPageSizes = JSON.parse(sessionStorage.getItem('pdfPageSizes') ?? '{}');
    this.excelPdf.pdfPageSize = 'A4';
    this.isForExcel = item == 'Excel';
    this.popupDataTitle.title = item == 'Excel' ? 'Excel Report' : 'PDF Report';
    [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
    const firstst = this.message.breadcrumbData.firstLevel;
    const secondnd = this.message.breadcrumbData.secondLevel;
    const thirdL = this.message.breadcrumbData.thirdLevel;
    const fourthL = this.message.breadcrumbData.fourthLevel;
    let fileName = "";
    if (firstst != null) {
      fileName = firstst + "_";
    }
    if (secondnd != null) {
      fileName = fileName + secondnd + "_";
    }
    if (thirdL != null) {
      fileName = fileName + thirdL + "_";
    }
    if (fourthL != null) {
      fileName = fileName + fourthL + "_";
    }
    this.reportName = fileName + Date.now();
    this.visibleExcelPdfPopup = this.dialog.open(this.excelPdfPopup, this.excelPdfPopupConfig);
    this.pdfColumnSelection = false;
    this.isSaveReport = false;
  }

  manuallyPicked: boolean;
  maxCountReached: boolean = false;
  selectedColumnsAsString: string = "";
  pdfPageSizes: any = [];
  @Input() excelPdf: any = {};
  onSelect() {
    if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
    this.convertArrayToString(this.selectedColumns);
  }
  onDeSelect() {
    this.onSelect();
  }
  onSelectAll(item: any[]) {
    if (item.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
    this.convertArrayToString(item);
  }
  onDeSelectAll(item: any[]) {
    if (item.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
    this.convertArrayToString(item);
  }
  convertArrayToString(array: any) {
    this.selectedColumnsAsString = array.join(', ');
  }
  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });
    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }
  onCheckboxChange(event: MatSlideToggleChange) {
    if (!event.checked) {
      [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
    }
  }
  //end excell & pdf
  htmlContent: any;
  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  getClobData(data: any, column: string, val: any, view: string) {
    console.log("prim", data);
    this.isProcessing = true;
    const formattedColumn = this.formatColumnName(column);
    this.htmlContent = val;
    this.editorComponent.openEditor(this.htmlContent, formattedColumn);
    this.isProcessing = false;
  }
  formatColumnName(column: string): string {
    return column
      .toLowerCase()
      .split('_')
      .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
  setPage4(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.findingDuedateTableReportDataList.length, page, this.perPage, targetpage);
    if (this.findingDuedateTableReportDataList.length > 0) {
      this.pagedItems4 = this.findingDuedateTableReportDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }

  paginationCall4(value: number) {
    this.perPage = value;
    this.setPage4(this.pager.currentPage, 0);
  }

  setPage3(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.findingClosureTableReportDataList.length, page, this.perPage, targetpage);
    if (this.findingClosureTableReportDataList.length > 0) {
      this.pagedItems3 = this.findingClosureTableReportDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }

  paginationCall3(value: number) {
    this.perPage = value;
    this.setPage3(this.pager.currentPage, 0);
  }
  selectBoxeForDepartmentCode() {
    for (const department of this.dropDownForDepartmentCode) {
      this.departmentCodeDropdown.push({
        valueExp: department.codelistCode,
        displayExp: department.codelistName
      });
    }
  }

  //more activity
  applyFilter(column: string, event: Event, val: any): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems3 = this.findingClosureTableReportDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems3 = this.findingClosureTableReportDataList.filter((item: any) => {
        const columnValue = item[column];
        // Check if columnValue is a string before calling toLowerCase()
        if (val === 'd') {
          if (columnValue) {
            let formattedDate = this.datePipe.transform(columnValue, 'dd-MMM-yyyy');
            console.log("columnValue2=", formattedDate);
            // Convert number to string before checking for inclusion
            return formattedDate ? formattedDate.toString().toLowerCase().includes(filter) : false;
          } else {
            return false;
          }

        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          // Convert number to string before checking for inclusion
          return columnValue.toString().toLowerCase().includes(filter);
        } else if (columnValue instanceof Date) {
          // Format date to string before checking for inclusion
          const formattedDate = columnValue.toISOString().substring(0, 10);
          return formattedDate.toLowerCase().includes(filter);
        }
        // If it's not a string, return false to exclude it from filtering
        return false;
      });
    }
  }
  applyFilter1(column: string, event: Event, val: any): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems4 = this.findingClosureTableReportDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems4 = this.findingClosureTableReportDataList.filter((item: any) => {
        const columnValue = item[column];
        // Check if columnValue is a string before calling toLowerCase()
        if (val === 'd') {
          if (columnValue) {
            let formattedDate = this.datePipe.transform(columnValue, 'dd-MMM-yyyy');
            console.log("columnValue2=", formattedDate);
            // Convert number to string before checking for inclusion
            return formattedDate ? formattedDate.toString().toLowerCase().includes(filter) : false;
          } else {
            return false;
          }

        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          // Convert number to string before checking for inclusion
          return columnValue.toString().toLowerCase().includes(filter);
        } else if (columnValue instanceof Date) {
          // Format date to string before checking for inclusion
          const formattedDate = columnValue.toISOString().substring(0, 10);
          return formattedDate.toLowerCase().includes(filter);
        }
        // If it's not a string, return false to exclude it from filtering
        return false;
      });
    }
  }

  moreActivityReportDetails(value: any) {
    if (value == "Default") {
      this.qmsservice.reportFor = value;
      this.breadcrumbComponent.thirdLevel = "";
      this.router.navigate(['/dashboard/ActivityReportComponent/', this.qmsservice.moduleName]);
    } else {
      this.qmsservice.reportFor = value;
      this.router.navigate(['/dashboard/MoreActivityReportDetailsComponent/', this.qmsservice.moduleName]);
      this.breadcrumbComponent.thirdLevel = value;
      this.breadcrumbComponent.secondLevel = this.qmsservice.moduleName;
    }
  }
  auditFindingReportDetails(value: any) {
    if (value == "Default") {
      this.qmsservice.reportFor = value;
      this.breadcrumbComponent.thirdLevel = "";
      this.router.navigate(['/dashboard/ActivityReportComponent/', this.qmsservice.moduleName]);
    } else {
      this.qmsservice.reportFor = value;
      this.router.navigate(['/dashboard/AuditReportFindingDetailComponent/', this.qmsservice.moduleName]);
      this.breadcrumbComponent.thirdLevel = value;
      this.breadcrumbComponent.secondLevel = this.qmsservice.moduleName;
    }
  }
  findingDueDate(value: any) {
    if (value == "Default") {
      this.qmsservice.reportFor = value;
      this.breadcrumbComponent.thirdLevel = "";
      this.router.navigate(['/dashboard/ActivityReportComponent/', this.qmsservice.moduleName]);
    } else {
      this.qmsservice.reportFor = value;
      this.breadcrumbComponent.thirdLevel = value;
      this.breadcrumbComponent.secondLevel = this.qmsservice.moduleName;
      this.router.navigate(['/dashboard/findingDueDate/', this.qmsservice.moduleName]);
      this.resetFunctionForButton();
      if (this.selectedGroupValue) {
        this.genFindnigReport();
      }
    }
  }
  followupDueDate(value: any) {
    if (value == "Default") {
      this.qmsservice.reportFor = value;
      this.breadcrumbComponent.thirdLevel = "";
      this.router.navigate(['/dashboard/ActivityReportComponent/', this.qmsservice.moduleName]);
    } else {
      this.qmsservice.reportFor = value;
      this.breadcrumbComponent.thirdLevel = value;
      this.breadcrumbComponent.secondLevel = this.qmsservice.moduleName;
      this.router.navigate(['/dashboard/followupDueDate/', this.qmsservice.moduleName]);

    }
  }
  ngOnChanges() {
    console.log(this.refreshbreadcrumb)
    this.message.breadcrumbData.secondLevel = this.qmsservice.moduleName + " > " + this.qmsservice.SelectedGroupNameAndValue[0].displayExp;
    this.message.breadcrumbData.thirdLevel = 'Report';
    this.message.breadcrumbData.fourthLevel = this.qmsservice.reportFor;
    if (this.breadcrumbComponent) {
      this.breadcrumbComponent.secondLevel = this.qmsservice.moduleName + " > " + this.qmsservice.SelectedGroupNameAndValue[0].displayExp;
      this.breadcrumbComponent.thirdLevel = 'Report';
      this.breadcrumbComponent.fourthLevel = this.qmsservice.reportFor;
    }
    this.refreshbreadcrumb = true;
    console.log(this.refreshbreadcrumb)
  }

  groupSearchText: string = '';
  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }
  onGroupValueSelect1st(item: any) {
    console.log("=====", item);
    this.handleDropDownValidation('groupNameAlert', item);
  }
  onGroupValueSelect(event: any, item: any) {
    if (event.isUserInput) {

      this.handleDropDownValidation('groupNameAlert', item)
    }
  }
  // @ViewChild('pdfColumnVal') pdfColumnVal: MatSelect;
  // pdfColumnSelection = false;
  @ViewChild('columns') columns: MatSelect;
  isAllColumns = false;
  @ViewChild('pdf') pdf: MatSelect;
  pdfColumnSelection = false;
  toggleAllSelection(value: any) {
    if (value == 'pdf') {
      if (this.pdfColumnSelection) this.pdf.options.forEach((item: MatOption) => item.select());
      else {
        this.pdf.options.forEach((item: MatOption) => item.deselect())
        this.selectedColumns = [];
      }
      setTimeout(() => {
        this.handleDropDownValidation('execl-pdf', this.selectedColumns)
        this.convertArrayToString(this.selectedColumns);
      });

    } else if (value == 'columns') {
      if (this.isAllColumns) this.columns.options.forEach((item: MatOption) => item.select());
      else {
        this.columns.options.forEach((item: MatOption) => item.deselect())
        this.selectedColumns = [];
      }
      setTimeout(() => {
        if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
        this.convertArrayToString(this.selectedColumns);
      });
    }
  }
  onPDFSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.pdfColumnSelection = this.excelPdf.dropDown.length == this.selectedColumns.length;
        this.convertArrayToString(this.selectedColumns);
      })
    }
  }
  onColumnSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
        this.convertArrayToString(this.selectedColumns);
        this.pdfColumnSelection = this.selectedColumns.length == this.excelPdf.dropDown.length;
      });
    }
  }
  dropDownDataForReportLogo: any;
  selectedReportLogoValue: any = null;

  reportLogoDropdown: any = [];
  imageIdList: any = [];
  organizationReportImageDetails: any = {};
  logoVals: any;
  selectBoxForReportLogo() {
    this.reportLogoDropdown = [];
    if (this.dropDownDataForReportLogo) {
      console.log("this.dropDownDataForReportLogo=", this.dropDownDataForReportLogo);
      console.log("this.dropDownDataForReportLogo.reportImageList", this.dropDownDataForReportLogo.reportImageList);
      if (this.dropDownDataForReportLogo.reportImageList == 'Default') {
        this.reportLogoDropdown = this.reportLogoDropdown.concat({
          valueExp: 0,
          displayExp: 'Default'
        });
      } else if (this.dropDownDataForReportLogo.reportImageList.includes(",")) {
        this.imageIdList = this.dropDownDataForReportLogo.reportImageList.split(",");
        for (let i = 0; i < this.imageIdList.length; i++) {
          if (i == 0 && this.imageIdList[i] == 'Default') {
            this.reportLogoDropdown = this.reportLogoDropdown.concat({
              valueExp: 0,
              displayExp: 'Default'
            });
          } else {
            console.log("this.imageIdList=", this.imageIdList);
            console.log("this.organizationReportImageDetails=", this.organizationReportImageDetails.length);
            for (const organizationReportImageDetail of this.organizationReportImageDetails) {

              console.log(
                "this.organizationReportImageDetails=",
                organizationReportImageDetail.reportImageId,
                this.imageIdList[i]
              );

              if (organizationReportImageDetail.reportImageId == this.imageIdList[i]) {

                this.reportLogoDropdown = this.reportLogoDropdown.concat({
                  valueExp: organizationReportImageDetail.reportImageId,
                  displayExp: organizationReportImageDetail.reportImageName
                });

              }
            }
          }
        }
      } else {
        for (const organizationReportImageDetail of this.organizationReportImageDetails) {
          if (organizationReportImageDetail.reportImageId == this.dropDownDataForReportLogo.reportImageList) {
            this.reportLogoDropdown = this.reportLogoDropdown.concat({
              valueExp: organizationReportImageDetail.reportImageId,
              displayExp: organizationReportImageDetail.reportImageName
            });
          }
        }
      }
      if (this.dropDownDataForReportLogo.defaultReportName != 'Default' && this.dropDownDataForReportLogo.defaultReportName != null) {
        for (const reportLogo of this.reportLogoDropdown) {
          if (reportLogo.valueExp == this.dropDownDataForReportLogo.defaultReportName) {
            this.selectedReportLogoValue = reportLogo.valueExp;
          }
        }
      } else {
        this.selectedReportLogoValue = this.reportLogoDropdown[0].valueExp;
      }
    } else {
      this.selectedReportLogoValue = [];
    }
  }
  onReportFooterSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (this.reportFooterFieldValidation != undefined) {
        this.reportFooterFieldValidation.style.color = '#005c8a';
      }
    }
  }

  ngOnChangesReportFooter() {
    this.isProcessing = true;
    this.appService.getCodeListsByGroup("REPORT_FOOTER").subscribe({
      next: (data: any) => {
        this.reportFooterDropdown1 = data;
        console.log("data", this.reportFooterDropdown1)
        this.selectBoxForFooter();
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
      }
    })
  }

  selectBoxForFooter() {
    this.reportFooterDropdown = [];
    for (const vals of this.reportFooterDropdown1) {
      if (vals.moduleList == "Common" || vals.moduleList.includes(this.qmsservice.moduleName)) {
        this.reportFooterDropdown.push({
          valueExp: vals.codelistName,
          displayExp: vals.codelistName
        });
        // }
      }
    }
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.selectedGroupValue = this.qmsservice.SelectedGroupNameAndValue[0].valueExp;
      this.refreshbreadcrumb = false;
      this.ngOnChanges();
      this.onGroupValueSelect1st({ valueExp: this.qmsservice.SelectedGroupNameAndValue[0].valueExp, displayExp: this.qmsservice.SelectedGroupNameAndValue[0].displayExp })
      console.log("data activity", this.qmsservice)
      forkJoin([
        this.appService.getCodeListsByGroup('AUDIT_DEPARTMENT'),
        this.appService.getQmsReportUsers(this.qmsservice.moduleName),
      ]).subscribe(([auditDepartment, groupdataList]) => {
        this.dropDownForDepartmentCode = auditDepartment;
        this.selectBoxeForDepartmentCode();
        this.groupdataList = groupdataList;
        this.selectBoxeForGroupValue();
        if (this.selectedGroupValue) {
          this.genFindnigReport();
        }
      });
    });
    this.isProcessing = true;
    this.appService.getOneQmsOrganizationReportImage().subscribe({
      next: (data: any) => {
        this.organizationReportImageDetails = data;
        this.appService.getQmsReportLogoByModuleAndGroupId("QMS", this.selectedGroupValue).subscribe((data: any) => {
          this.dropDownDataForReportLogo = data;
          this.selectBoxForReportLogo();
          this.isProcessing = false;
        });
      }, error: (error: any) => {
        this.isProcessing = false;
      }
    })
    this.ngOnChangesReportFooter();
  }
}
